/**
 * Which custom model the editor's "Add to training data" panel sends to.
 *
 * A session does not say which custom model a correction is for: sessions are
 * usually transcribed with the base language, not the custom model. The panel
 * used to fall back to the last model picked in this tab, or the first one in
 * the list. On staging (2026-09-23) that sent clips to model 224 while the
 * customer had model 214 open, and 214's dataset never grew.
 *
 * Opening a model's page now makes it the target, and the choice lives in
 * ``localStorage`` because the editor is normally open in a different tab,
 * which ``sessionStorage`` does not share.
 */
const KEY = 'cm-last-model-id';

export const getContributionTarget = (): number | null => {
  const value = Number(localStorage.getItem(KEY));
  return Number.isFinite(value) && value > 0 ? value : null;
};

export const setContributionTarget = (modelId: number): void => {
  if (Number.isFinite(modelId) && modelId > 0) {
    localStorage.setItem(KEY, String(modelId));
  }
};
